<form [formGroup]="addressForm">
  <div class="flex">
    <mat-form-field
      class="flex-auto">
      <mat-label>Address 1</mat-label>
      <input matInput type="text" id="address1" formControlName="address1" [placeholder]="'Church street'">
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field
      class="flex-auto ml-2">
      <mat-label>Address 2</mat-label>
      <input matInput type="text" id="address2" formControlName="address2" [placeholder]="'Church street'">
      <mat-error>This field is required</mat-error>
    </mat-form-field>
  </div>

  <div class="flex">
    <mat-form-field
      class="flex-auto">
      <mat-label>City</mat-label>
      <input matInput type="text" id="city" formControlName="city" [placeholder]="'Banagalore'">
      <mat-error>This field is required</mat-error>
    </mat-form-field>
  </div>

  <div class="flex">
    <mat-form-field
      class="flex-auto">
      <mat-label>Taluk</mat-label>
      <input matInput type="text" id="taluk" formControlName="taluk" [placeholder]="'South'">
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field
      class="flex-auto ml-2">
      <mat-label>District</mat-label>
      <input matInput type="text" id="district" formControlName="district" [placeholder]="'Bangalore'">
      <mat-error>This field is required</mat-error>
    </mat-form-field>
  </div>

  <!-- Add other fields based on your requirements -->


  @if (showCountry == true || showState == true) {
    <div class="flex">
      @if (showState) {
        <mat-form-field class="flex-auto" [ngClass]="{'mr-2': showCountry}">
          <mat-label>State</mat-label>
          <input matInput type="text" id="state" formControlName="state">
        </mat-form-field>
      }
      @if (showCountry) {
        <mat-form-field class="flex-auto">
          <mat-label>Country</mat-label>
          <input matInput type="text" id="country" formControlName="country">
        </mat-form-field>
      }
    </div>
  }

  <div class="flex">
    <mat-form-field class="flex-auto">
      <mat-label>Pin Code</mat-label>
      <input matInput type="number" id="pincode" formControlName="pinCode">
    </mat-form-field>
  </div>
</form>
